<template>    
    <modal v-model="show"
           max-width="700"
           :has-padding="false"
           @input="emitInput">    
        <div>
            <app-vpn-support-body @close="show = false"></app-vpn-support-body>
        </div>
    </modal>    
</template>

<script>
    import AppVpnSupportBody from './components/VpnSupportBody'
    import EventBus from '@packages/event-bus'
    import Modal from "@/components/generic/Modal";

    export default {
        components: {
            AppVpnSupportBody,
            Modal
        },

        data() {
            return {
                show: false
            }
        },

        methods: {
            emitInput(value) {
                this.$emit("input", value);
            },
            editVpnSupportHandler(data) {
                this.show = true;
                EventBus.$emit('RESET_BODY_VPN_SUPPORT', JSON.parse(JSON.stringify(data)))
            },
            createVpnSupportHandler() {
                this.show = true;
                EventBus.$emit('RESET_BODY_VPN_SUPPORT')
            },
            loadVpnSupportHandler() {
                this.show = false;
                EventBus.$emit('LOAD_VPN_SUPPORT')
            }
        },


        mounted() {
            EventBus.$on('EDIT_VPN_SUPPORT', this.editVpnSupportHandler)
            EventBus.$on('CREATE_VPN_SUPPORT', this.createVpnSupportHandler)
            EventBus.$on('RESET_VPN_SUPPORT', this.loadVpnSupportHandler)
        },

        beforeDestroy() {
            EventBus.$off('EDIT_VPN_SUPPORT', this.editVpnSupportHandler)
            EventBus.$off('CREATE_VPN_SUPPORT', this.createVpnSupportHandler)
            EventBus.$off('RESET_VPN_SUPPORT', this.loadVpnSupportHandler)
        },

    }
</script>

<style scoped>

</style>
